import React from "react";
import { CreditCard, MessageSquare, Phone, Mail, Repeat, Sparkles } from "lucide-react";
import { SMS_HREF, TEL_HREF, PHONE_DISPLAY } from "./constants";
import { track } from "@/lib/analytics";

export function Footer() {
  return (
    <footer className="bg-[#000000] text-[#C9C9C9]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/logo.png"
                alt="Glenwood Gutter Guy logo"
                className="w-10 h-10 rounded-sm object-contain bg-white p-1"
              />
              <div className="font-display text-lg text-white">
                Glenwood Gutter Guy
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed max-w-xs">
              Gutter cleaning, gutter cover installation, and residential window
              screen replacement across Southwest Iowa. Run by Mike Harrison —
              one neighbor, one ladder, done right.
            </p>
            <div className="mt-4 text-sm font-semibold text-white">
              GlenwoodGutterGuy.com
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-white mb-4">
              Reach Mike
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <MessageSquare className="w-4 h-4 text-[#5FBE1F]" />
                <a
                  href={SMS_HREF}
                  onClick={() => track("text_gutters_click", { location: "footer" })}
                  className="hover:text-white"
                  data-testid="footer-sms"
                >
                  Text "Gutters" to {PHONE_DISPLAY}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#5FBE1F]" />
                <a
                  href={TEL_HREF}
                  onClick={() => track("phone_call_click", { location: "footer" })}
                  className="hover:text-white"
                  data-testid="footer-tel"
                >
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#5FBE1F]" />
                <a href="#contact" className="hover:text-white" data-testid="footer-form">
                  Send via contact form
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#5FBE1F]" />
                <a href="/blog" className="hover:text-white" data-testid="footer-blog">
                  Read the blog
                </a>
              </li>
              <li className="flex items-center gap-2">
                <CreditCard className="w-4 h-4 text-[#5FBE1F]" />
                <a href="/pay" className="hover:text-white" data-testid="footer-pay">
                  Pay online
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Repeat className="w-4 h-4 text-[#5FBE1F]" />
                <a href="/plans" className="hover:text-white" data-testid="footer-plans">
                  Membership plans
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Sparkles className="w-4 h-4 text-[#5FBE1F]" />
                <a href="/member" className="hover:text-white" data-testid="footer-member">
                  Member sign in
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-white mb-4">
              Coverage
            </div>
            <p className="text-sm leading-relaxed">
              Glenwood, Pacific Junction, Malvern, Silver City, Mineola, Tabor,
              Stanton, Shenandoah, Essex, Council Bluffs, Logan, Woodbine,
              Dunlap, Red Oak, New Market, Bedford and the surrounding SW Iowa
              communities.
            </p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#4A4A46]/40 flex flex-col sm:flex-row gap-2 justify-between items-start sm:items-center text-xs">
          <div>© {new Date().getFullYear()} Glenwood Gutter Guy · Mike Harrison</div>
          <div>Built with care · Local SW Iowa</div>
        </div>
      </div>
    </footer>
  );
}
